import { BusinessRules } from '../BusinessRules';

const rules: Partial<BusinessRules> = {
  showLogoTelaBoletos: (p) => p?.parcelasGerenciadas?.demaisParcelas === false
    && (p.parcelasGerenciadas.primeiraParcela === false
      || p.parcelas?.find((b) => b.numeroParcela === 1)?.quitada === true),
  showLogoTelaPropostas: (p) => p?.parcelasGerenciadas.demaisParcelas === false,
  nomeAplicativo: 'Portal do Cartão',
  linkAplicativo: 'https://www.portaldocartao.com.br/',
  mensagemAcompanhamentoAplicativo: 'Após o pagamento da entrada, o restante da sua negociação poderá ser acompanhado diretamento no Portal do Cartão.',
  mensagemColchaoNaoGerenciado: 'Todas as atualizações das negociações com a CredSystem devem ser acompanhadas exclusivamente através do seu portal. Nele você encontrará informações detalhadas sobre o status dos seus pagamentos.',
};

export default rules;
